import { store } from "../../redux";
import { getLabel } from "../../hooks/use-labels";
import { USAGE_OPTIONS } from "../../features/profile/usageOptions";

export function formDataFields(submitted) {
  const { publicAPIs } = store.getState();
  const { countryOptions } = publicAPIs;

  return {
    info: {
      title: "Profile",
      subTitle: "",
      viewHeight: true,
      fields: {
        profilePicUrl: {
          elementConfigs: {
            label: "",
            type: "file",
          },
          value: "",
        },
        firstName: {
          elementConfigs: {
            label: submitted
              ? getLabel("firstNameLabel")
              : getLabel("fullNameLabel"),
            type: "string",
            required: true,
            maxLength: 2147483647,
            minLength: 3,
          },
          value: "",
        },
        ...(submitted && {
          lastName: {
            elementConfigs: {
              label: getLabel("lastNameLabel"),
              type: "string",
              required: true,
              maxLength: 2147483647,
              minLength: 3,
            },
            value: "",
          },
        }),
        email: {
          elementConfigs: {
            label: "Email",
            type: "email",
            required: true,
            disabled: true,
            verified: true,
            containerClass: "has-verified-badge",
          },
          value: "",
        },
        ...(submitted && {
          phoneNumber: {
            elementConfigs: {
              label: "Phone Number",
              type: "string",
              required: false,
              disabled: true,
              verified: true,
              containerClass: "has-verified-badge",
            },
            value: "",
          },
        }),

        type: {
          elementConfigs: {
            label: getLabel("usageTypeLabel"),
            type: "select",
            required: true,
            options: USAGE_OPTIONS,
          },
          value: "",
        },
      },
      formName: ["file", "name", "email"],
      formHandler: "info",
      text: "Save",
      footerText: "Powered by Sayagie",
    },
    "address-information": {
      title: "Address Information",
      subTitle: "Enter the Address Information",
      viewHeight: true,
      fields: {
        address1: {
          elementConfigs: {
            label: "Street",
            type: "string",
            required: true,
          },
          value: "",
        },
        countryCode: {
          elementConfigs: {
            label: "Country",
            type: "select",
            required: true,
            options: countryOptions,
            disabled: true,
          },
          value: "",
        },
        stateCode: {
          elementConfigs: {
            label: "State",
            type: "api-select",
            apiURL: ``,
            labelKey: "name",
            metaKey: "name",
            valueKey: "code",
            apiKey: "states",
            valueOnly: true,
            required: true,
            disabled: true,
          },
          value: "",
        },
        city: {
          elementConfigs: {
            label: "City",
            type: "api-select",
            apiURL: ``,
            labelKey: "name",
            metaKey: "name",
            valueKey: "code",
            apiKey: "cities",
            valueOnly: true,
            required: true,
            disabled: true,
          },
          value: "",
        },
        postalCode: {
          elementConfigs: {
            label: "Zip code (Optional)",
            type: "string",
            required: false,
            maxLength: 12,
            minLength: 5,
          },
          value: "",
        },

        digitalCode: {
          elementConfigs: {
            label: "Digital code (Optional)",
            type: "string",
            required: false,
            maxLength: 12,
            minLength: 5,
          },
          value: "",
        },

        location: {
          elementConfigs: {
            label: "Pin Your Location",
            type: "location",
            required: true,
            imgSrc: "/assets/icons/pin-location.svg",
          },
          value: { latitude: 0, longitude: 0 },
        },
      },
      formName: ["address"],
      formHandler: "address-info",
      text: "Apply",
      footerText: "Powered by Sayagie",
    },
  };
}
